module.exports = __webpack_public_path__ + "img/83.b557deb5.jpg";